/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar, SnackbarCloseReason } from '@mui/material';
import { IVFormErrors, VForm, VTextField, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { NfeService } from '../../../shared/services/api/fiscal/nfe/NfeService';
import { Environment } from '../../../shared/environment';

interface IFormData {
  justificativa: string;
  nseqevento: number;
}

export interface ConfirmationDialogRawProps {
  id: string;
  open: boolean;
  status: number;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  justificativa: yup.string().required().min(15),
  nseqevento: yup.number().required(),
});


export const DialoCancelar: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { formRef, save, } = useVForm();
  const { onClose, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');


  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);

  };

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        NfeService.cancelarnfe(props.id, dadosValidados)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              // window.open(Environment.URL_PDFNFE+result, '_blank');
              // onClose();
              const blob = new Blob([result], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');
              setTimeout(() => URL.revokeObjectURL(url), 10000);
              onClose();
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      {...other}
      maxWidth='xl'
      fullWidth sx={{ m: 0.1, maxWidth: '100%', }}
    >
      <DialogTitle>Cancelar Nota Fiscal</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1} >
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={3}>
                <VTextField
                  fullWidth
                  name='nseqevento'
                  label='Sequencia'
                  disabled={isLoading}
                />
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={12}>
                <VTextField
                  fullWidth
                  name='justificativa'
                  label='Justificativa'
                  disabled={isLoading}
                />
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>

  );
};